"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = exports["default"] = exports.AssetDetails = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _mapping = require("@nicbase/mapping");

var _nicbaseSecurity = require("nicbase-security");

var _nicbaseTranslation = require("nicbase-translation");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    linkedPortals: state.informationLists.linkedPortals
  };
};

exports.mapStateToProps = mapStateToProps;

var AssetDetails = function AssetDetails(_ref) {
  var _tour$dataRequest, _tour$dataRequest2;

  var tour = _ref.tour,
      linkedPortals = _ref.linkedPortals;
  var Asset;

  if (tour.assetId) {
    Asset = (0, _mapping.assetToIcon)(tour.assetType, 'STANDING');
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "pt-0 px-1 pb-1"
  }, tour.serviceProviderPortalId ? /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.headers.serviceProviderPortalId"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
      className: "bold"
    }, value, ":"), " ", (linkedPortals[tour.serviceProviderPortalId] || {}).name);
  }) : null, (_tour$dataRequest = tour.dataRequest) !== null && _tour$dataRequest !== void 0 && _tour$dataRequest.haulerPortalId ? /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.dataRequestedFromHauler"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
      className: "bold"
    }, value, ":"), " ", (linkedPortals[tour.dataRequest.haulerPortalId] || {}).name);
  }) : null, ((_tour$dataRequest2 = tour.dataRequest) === null || _tour$dataRequest2 === void 0 ? void 0 : _tour$dataRequest2.haulerEmail) && /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.dataRequestedFromApp"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
      className: "bold"
    }, value, ":"), " ", tour.dataRequest.haulerEmail);
  }), tour.appLicensePlate && /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.appLicensePlate"
  }, function (value) {
    return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
      className: "bold"
    }, value, ":"), " ", tour.appLicensePlate);
  }), Asset && /*#__PURE__*/_react["default"].createElement("div", {
    className: "my-2 mx-0 flex items-center"
  }, /*#__PURE__*/_react["default"].createElement(Asset, {
    className: "mr-2"
  }), /*#__PURE__*/_react["default"].createElement("span", null, tour.assetName)));
};

exports.AssetDetails = AssetDetails;
AssetDetails.propTypes = {
  tour: _propTypes["default"].shape({
    assetId: _propTypes["default"].number,
    assetName: _propTypes["default"].string,
    assetType: _propTypes["default"].number,
    appLicensePlate: _propTypes["default"].string,
    serviceProviderPortalId: _propTypes["default"].number,
    sharedWithPortals: _propTypes["default"].arrayOf({}),
    dataRequest: _propTypes["default"].shape({
      haulerPortalId: _propTypes["default"].number,
      haulerEmail: _propTypes["default"].string
    })
  }).isRequired,
  linkedPortals: _propTypes["default"].shape().isRequired
};
AssetDetails.defaultProps = {};

var _default = (0, _nicbaseSecurity.authorize)('PORTAL')(null)((0, _reactRedux.connect)(mapStateToProps)(AssetDetails));

exports["default"] = _default;